<script setup lang="ts">
import type { SelectTriggerProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { ChevronDown } from '@lucide/vue'
import { SelectIcon, SelectTrigger, useForwardProps } from 'reka-ui'
import { cn } from '@ds/lib/utils'

const props = defineProps<SelectTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectTrigger
    v-bind="forwardedProps"
    :class="cn(
      // Reconciled to DSInput so a select and a text field are the same control:
      // 40px, card fill, 16px Medium, ds radius. shadcn ships h-10/text-sm on the
      // canvas fill with a ring-offset focus, none of which match.
      'ds-control',
      'flex h-10 w-full items-center justify-between text-start',
      'px-3 bg-card text-foreground data-[placeholder]:text-muted-foreground',
      'font-ds font-medium text-base',
      'border border-input rounded-ds-md',
      'transition-[border-color,box-shadow] duration-ds-fast ease-ds-standard',
      'focus:outline-none disabled:cursor-not-allowed disabled:bg-muted',
      '[&>span]:truncate',
      props.class,
    )"
  >
    <slot />
    <SelectIcon as-child>
      <ChevronDown class="size-4 shrink-0 text-muted-foreground" />
    </SelectIcon>
  </SelectTrigger>
</template>
